import { Component, computed, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { DirectoryService } from '@/services/api/directory.service';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { JobTag } from '@/models/directory-user.model';
import { CardModule } from 'primeng/card';
import { PermRole } from '@/models/user-data.model';
import { PopoverModule } from 'primeng/popover';

@Component({
  selector: 'directory-bulk-panel',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SelectModule,
    ButtonModule,
    ConfirmDialogModule,
    CardModule,
    PopoverModule,
  ],
  styles: [`
  `],
  template: `
<p-button (click)="op.toggle($event)" icon="pi pi-add" label="Bulk Actions" [disabled]="bulkUsers.length === 0"/>
    <!-- <p-button 
      [label]="isExpanded() ? 'Bulk Actions' : 'Bulk Actions'" 
      [icon]="isExpanded() ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" 
      (click)="toggleExpanded()" 
      [disabled]="bulkUsers.length === 0"
      [outlined]="!isExpanded()"
      styleClass="bulk-actions-button">
    </p-button> -->
    <p-popover #op>
    <div class="bulk-actions-content">
            <span>Add Tags:</span>
            <p-select 
                [options]="availableTags" 
                optionLabel="name" 
                [(ngModel)]="bulkTag" 
                [disabled]="bulkUsers.length === 0"
                placeholder="Select a tag"
                styleClass="flex-1">
            </p-select>
            </div>
            <div class="bulk-actions-content">
            <span>Add Office:</span>
            <p-select 
                [options]="offices" 
                optionLabel="name" 
                [(ngModel)]="bulkOffice" 
                [disabled]="bulkUsers.length === 0"
                placeholder="Select a office"
                styleClass="flex-1">
            </p-select>
            </div>
            <div class="bulk-actions-content">
            <p-button 
                label="Apply" 
                icon="pi pi-check" 
                (click)="confirmBulkTags($event)" 
                [disabled]="bulkUsers.length === 0 || !bulkTag">
            </p-button>
            </div>
</p-popover>
    
  `
})
export default class DirectoryBulkPanelComponent {
  directoryService = inject(DirectoryService);
  confirmationService = inject(ConfirmationService);
  bulkTag:JobTag | null = null;
  bulkOffice:PermRole | null = null;
  isExpanded = signal(false);

  constructor() {
  }

  get bulkUsers() { return this.directoryService.bulkUsers(); }

  get users() { return this.directoryService.userList(); }

  get availableTags() { return this.directoryService.availableTags(); }

  get offices() { return this.directoryService.officePerms(); }

  toggleExpanded() {
    this.isExpanded.set(!this.isExpanded());
  }

  onTagChange() {
    // Optional: handle tag change without confirmation
  }

  bulkTagChange(event: any) {
    console.log('bulk tag changed', event, this.bulkUsers, this.bulkTag);
    if(this.bulkTag && this.bulkUsers.length > 0) {
      const users = this.bulkUsers.map(u => u.id);
      this.directoryService.bulkTags(users, this.bulkTag.id);
    }
  }

  bulkOfficeChange(event: any) {
    console.log('bulk office changed', event, this.bulkUsers, this.bulkOffice);
    if(this.bulkOffice && this.bulkUsers.length > 0) {
      const users = this.bulkUsers.map(u => u.id);
      this.directoryService.bulkLocation(users, this.bulkOffice.PermRoleID);
    }
  }

  cleanup() {
    this.bulkTag = null;
    this.bulkOffice = null;
    this.directoryService.bulkUsers.set([]);
    this.isExpanded.set(false);
  }

  confirmBulkTags(event: any) {
    if (!this.bulkTag) return;
    
    this.confirmationService.confirm({
      message: `Are you sure you want to add the ${this.bulkTag?.name} tag to the selected users?`,
      accept: () => {
        this.bulkTagChange(event);
      }
    });
  }

  apply() {
    if((!this.bulkTag && !this.bulkOffice) || this.bulkUsers.length > 0) {
      return;
    }
    if(this.bulkTag) {
      this.bulkTagChange(event);
    }
    if(this.bulkOffice) {
      this.bulkOfficeChange(event);
    }
    this.cleanup();
  }

}
